import { CheckBoxWithLabelWidget, TabStyles,TextAreaWidget,TextFieldWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';

import { SubscribeRecipientPicker } from './SubscribeRecipientPicker';

const SUBJECT_MAX_LENGTH: number = 256;
const MESSAGE_MAX_LENGTH: number = 2000;
const ROOT_CLASS: string = 'FlowSubscriptionUberContent';

const titleClass = cssClass(ROOT_CLASS, 'title', {
  display: 'block',
  paddingBottom: TabStyles.Spacing.MediumSpace,
});

const inputClass = cssClass(ROOT_CLASS, 'input', {
  width: '100%',
  paddingTop: TabStyles.Spacing.MediumSpace,
});

const textAreaClass = cssClass(ROOT_CLASS, 'textarea', {
  width: '100%',
  paddingTop: TabStyles.Spacing.MediumSpace,
});

export interface FlowSubscriptionDialogContentProps {
  readonly shouldSendToMe: boolean;
  readonly subjectValue: string;
  readonly messageValue: string;
  readonly onShouldSendToMeToggled: () => void;
  readonly onSubjectChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  readonly onMessageChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const FlowSubscriptionDialogContent: React.FC<FlowSubscriptionDialogContentProps>  = (props: FlowSubscriptionDialogContentProps) => {
  return (
    <>
      <span className={titleClass}>{Messages.flowSubscriptionsAddFlowSubscription()}</span>
      <SubscribeRecipientPicker
        recipients={[{id: 12, name: 'baz', userCount: 12, recipientType: 'GROUP'}, {id: 12, friendlyName: 'bar', username: 'bar', hasEmail: true, recipientType: 'USER'}]}
        label={Messages.subscriptionRecipiantPickerLabel()}
        placeholder={Messages.subscriptionRecipiantPickerPlaceholder()}
      />
      <CheckBoxWithLabelWidget
        label={Messages.flowSubscriptionsSendToMe()}
        checked={props.shouldSendToMe}
        handleChange={props.onShouldSendToMeToggled}
        testId={'flow-subscription-send-to-me'}
      />
      <TextFieldWidget
        testId='flow-subscription-subject'
        label={Messages.flowSubscriptionsSubject()}
        kind={'line'}
        maxLength={SUBJECT_MAX_LENGTH}
        onChange={props.onSubjectChange}
        value={props.subjectValue}
        valid={props.subjectValue.length > SUBJECT_MAX_LENGTH || props.subjectValue === '' ? false : undefined}
        style={{width: '100%'}}
        className={inputClass}
      />
      <TextAreaWidget
        label={Messages.flowSubscriptionsEmailMessage()}
        testId={'flow-subscription-message'}
        rows={2}
        onChange={props.onMessageChange}
        value={props.messageValue}
        maxLength={MESSAGE_MAX_LENGTH}
        className={textAreaClass}
        valid={props.messageValue.length > MESSAGE_MAX_LENGTH ? false : undefined}
        style={{width: '100%'}}
      />
    </>
  );
};

FlowSubscriptionDialogContent.displayName = 'FlowSubscriptionDialogContent';
